import { withClassName } from 'lp-hoc'

const SectionHeader = withClassName('section-header')('div')

export default SectionHeader
